import { render, staticRenderFns } from "./uploadSelf.vue?vue&type=template&id=390cb0b2&scoped=true&"
import script from "./uploadSelf.vue?vue&type=script&lang=js&"
export * from "./uploadSelf.vue?vue&type=script&lang=js&"
import style0 from "./uploadSelf.vue?vue&type=style&index=0&id=390cb0b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390cb0b2",
  null
  
)

export default component.exports